export default __webpack_public_path__ + "static/media/refresh.bd40fab7.svg";